import {
  JobSupport3fdjh0rbee4be as JobSupport,
  get_COMPLETING_WAITING_CHILDREN3nnjgv5wv89p1 as get_COMPLETING_WAITING_CHILDREN,
} from './JobSupport.mjs';
import {
  Key_instance2tirv2rj82ml4 as Key_instance,
  Job29shfjfygy86k as Job,
} from './Job.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from './Debug.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally,
  toState1lqvgl5d0bogr as toState,
} from './CompletionState.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from './CoroutineExceptionHandler.mjs';
import { get_coroutineName3a0vy840b4l1i as get_coroutineName } from './CoroutineContext.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from './CoroutineScope.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractCoroutineClass;
function AbstractCoroutine() {
  if (AbstractCoroutineClass === VOID) {
    class $ extends JobSupport() {
      constructor(parentContext, initParentJob, active) {
        super(active);
        if (initParentJob) {
          this.ca2(parentContext.cd(Key_instance));
        }
        this.fa2_1 = parentContext.gp(this);
      }
      pc() {
        return this.fa2_1;
      }
      ga2() {
        return this.fa2_1;
      }
      ha2() {
        return super.ha2();
      }
      ia2(value) {
      }
      ja2(cause, handled) {
      }
      ka2() {
        return get_classSimpleName(this) + ' was cancelled';
      }
      la2(state) {
        if (state instanceof CompletedExceptionally()) {
          this.ja2(state.ma2_1, state.oa2());
        } else {
          this.ia2((state == null ? true : !(state == null)) ? state : THROW_CCE());
        }
      }
      rc(result) {
        var state = this.pa2(toState(result));
        if (state === get_COMPLETING_WAITING_CHILDREN())
          return Unit_instance;
        this.qa2(state);
      }
      qa2(state) {
        return this.ra2(state);
      }
      sa2(exception) {
        handleCoroutineException(this.fa2_1, exception);
      }
      ta2() {
        var tmp0_elvis_lhs = get_coroutineName(this.fa2_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return super.ta2();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var coroutineName = tmp;
        return '"' + coroutineName + '":' + super.ta2();
      }
      ua2(start, receiver, block) {
        start.xa2(block, receiver, this);
      }
    }
    initMetadataForClass($, 'AbstractCoroutine', VOID, VOID, [JobSupport(), Job(), Continuation(), CoroutineScope()], [0]);
    AbstractCoroutineClass = $;
  }
  return AbstractCoroutineClass;
}
//region block: exports
export {
  AbstractCoroutine as AbstractCoroutine2jzyhqo91sb0o,
};
//endregion

//# sourceMappingURL=AbstractCoroutine.mjs.map
